import { useQueryClient } from "@tanstack/react-query";
import klydoApi from "../../../api/klydo";
import useKlydoQuery from "../../../components/hooks/useKlydoQuery";

const useGetKlydosByIds = (klydoIds: string[] = []) => {
  const queryClient = useQueryClient();
  const sortedIds = klydoIds.slice().sort();

  const {
    data: klydos = [],
    isLoading,
    error,
  } = useKlydoQuery({
    queryKey: ["klydos-by-ids", ...sortedIds],
    queryFn: () => klydoApi.getKlydosByIds(klydoIds),
    enabled: klydoIds.length > 0,
    keepPreviousData: true,
  });

  const fetchKlydosByIds = (ids: string[]) => {
    const sorted = ids.slice().sort();
    return queryClient.fetchQuery({
      queryKey: ["klydos-by-ids", ...sorted],
      queryFn: () => klydoApi.getKlydosByIds(ids),
    });
  };

  return { klydos, isLoading, error, fetchKlydosByIds };
};

export default useGetKlydosByIds;
